import React, { useEffect } from 'react';

const PaymentPage = () => {
  useEffect(() => {
    // تحميل سكربت MyFatoorah
    const script = document.createElement('script');
    script.src = 'https://demo.myfatoorah.com/payment/v1/session.js';
    script.async = true;
    script.onload = () => {
      // التهيئة بعد تحميل السكربت
      if (window.myfatoorah) {
        const sessionId = "15dc7558-1767-4044-8d04-b71d19a25e0d";
        const countryCode = "KWT";
        const currencyCode = "KWD";
        const amount = 120.0;

        const config = {
          sessionId,
          countryCode,
          currencyCode,
          amount,
          containerId: "unified-session",
          paymentOptions: ["ApplePay", "GooglePay", "Card", "KNET"],
          supportedNetworks: ["visa", "masterCard", "mada"],
          language: "ar",
          callback: payment,
          settings: {
            applePay: {
              //supportedNetworks: "["visa", "masterCard", "mada"]",
              //containerId: "apple-pay",
              //callback: paymentAP,
              style: {
                frameHeight: "50px",
                frameWidth: "100%",
                button: {
                  height: "40px",
                  type: "pay", //["plain", "buy", "pay", "checkout", "continue", "book", "donate", "subscribe", "reload", "add", "topup", "order", "rent", "support", "contribute", "setup", "tip"]
                  borderRadius: "0px"
                }
              },
              useCustomButton: false,
              sessionStarted: sessionStarted,
              sessionCanceled: sessionCanceled,
              requiredShippingContactFields: ["postalAddress", "name", "phone", "email"],
              requiredBillingContactFields: ["postalAddress", "name", "phone"]
            },
            googlePay: {
              //supportedNetworks: ["visa", "masterCard"],
              //containerId: "google-pay",
              //callback: paymentGP,
              style: {
                frameHeight: "50px",
                frameWidth: "100%",
                button: {
                  height: "40px",
                  type: "pay", //Accepted texts ["book", "buy", "checkout", "donate", "order", "pay", "plain", "subscribe"]
                  borderRadius: "0px",
                  color: "black",
                  language: "en"
                }
              }
            },
            card: {
              onCardBinChanged: handleCardBinChanged,
              style: {
                hideNetworkIcons: false,
                cardHeight: "180px",
                tokenHeight: "180px",
                input: {
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Times",
                  inputHeight: "32px",
                  inputMargin: "-1px",
                  borderColor: "black",
                  borderWidth: "1px",
                  borderRadius: "30px",
                  outerRadius: "10px",
                  //boxShadow: "0 0 10px 5px purple, 0 0 15px 10px lightblue"
                  placeHolder: {
                    holderName: "Name On Card",
                    cardNumber: "Number",
                    expiryDate: "MM/YY",
                    securityCode: "CVV"
                  }
                },
                text: {
                  saveCard: "Save card info for future payments",
                  addCard: "Use another Card!",
                  deleteAlert: {
                    title: "Delete",
                    message: "Are you sure?",
                    confirm: "YES",
                    cancel: "NO"
                  }
                },
                label: {
                  display: false,
                  color: "black",
                  fontSize: "13px",
                  fontWeight: "bold",
                  fontFamily: "Times",
                  text: {
                    holderName: "Card Holder Name",
                    cardNumber: "Card Number",
                    expiryDate: "Expiry Date",
                    securityCode: "Security Code"
                  }
                },
                error: {
                  borderColor: "red",
                  //boxShadow: "0 0 10px 5px purple, 0 0 15px 10px lightblue",
                  borderRadius: "8px"
                },
                button: {
                  useCustomButton: false,
                  //onButtonClicked: submit,//You will have to implement this function and call myfatoorah.submitCardPayment()
                  textContent: "Pay",
                  fontSize: "16px",
                  fontFamily: "Times",
                  color: "white",
                  backgroundColor: "#4daee0",
                  height: "30px",
                  borderRadius: "8px",
                  width: "70%",
                  margin: "0 auto",
                  cursor: "pointer"
                },
                separator: {
                  useCustomSeparator: false,
                  textContent: "Enter your card",
                  fontSize: "20px",
                  color: "#4daee0",
                  fontFamily: "sans-serif",
                  textSpacing: "2px",
                  lineStyle: "dashed",
                  lineColor: "black",
                  lineThickness: "3px"
                }
              }
            }
          }
        };
      
        function sessionCanceled() {
          console.log("Failed");
        }

        function sessionStarted() {
          console.log("Start");
        }
        //This function enables you to update the amount displayed on Apple Pay and Google Pay after the initiation of the config.
        function updateAmount(amount) {
          script.updateAmount(amount);
        }

        //You need to implement here the handling of the callback for Apple Pay
        function paymentAP(response) {
          //Here you need to pass session id to you backend here
          var sessionId = response.sessionId;
          var cardBrandAP = response.card.brand;

          console.log("SessionID via AP >> ", sessionId);
          console.log("cardBrand via AP >> ", cardBrandAP);
          console.log("response via AP >> ", response);
        }

        //You need to implement here the handling of the callback for Google Pay
        function paymentGP(response) {
          //Here you need to pass session id to you backend here
          var sessionId = response.sessionId;
          var cardBrandGP = response.card.brand;

          console.log("SessionID via GP >> ", sessionId);
          console.log("cardBrand via GP >> ", cardBrandGP);
          console.log("response via GP >> ", response);
        }

        //Here you implement the function of clicking on the payment button using your own function
        function submit() {
          console.log("Submit");
          script.submitCardPayment(); //It is mandatory to call this function
        }

        //Here you implement the function of clicking on your custom payment button
        function customSubmit() {
          console.log("Custom Submit");
          script.submitCardPayment(); //It is mandatory to call this function
        }

        function handleCardBinChanged(response) {
          console.log(response);
        }

        //Here you specify the actions you need to do when customer clicks on your custom Apple Pay button
        function startApplePay() {
          console.log("using custom button");
          script.initApplePayPayment(); //It is mandatory to call this function
        }
        // تشغيل المكونات
        window.myfatoorah.init(config);
        // window.myfatoorah.initCvv(configCvvView);
      }
    };
    document.body.appendChild(script);
  }, []);

  //This function enables you to update the amount displayed on Apple Pay and Google Pay after the initiation of the config.
  function updateAmount(amount) {
    window.myfatoorah.updateAmount(amount);
  }
  // #region STC Pay
  function stcSessionStarted(data) {
    console.log("STC Session Started\n" + JSON.stringify(data));
  }

  //The event listener is used to listen to the Redirection URL after the  customer completes the 3DS Challenge
window.addEventListener("message", function (event) { 
        if (!event.data) return;
        try {
            //The redirection URL is returned in the message
            var message = JSON.parse(event.data);
          
            //Proceed only with the following steps if the sender is exactly "MF-3DSecure"
            if (message.sender == "MF-3DSecure") {
              var url = message.url;
            //Here, you need to handle the next action, and here are some suggestions:
            //Redirect the full page to the received URL.
            //Load the received URL in your iframe.
            //Close the iframe and display the result on the same page. You can use AJAX requests to your server with the payment ID to confirm the transaction status (invoke GetPaymentStatus) and display the result accordingly.
            }
        } catch (error) {
            return;
        }
    }, false);	
  //Embedded Functions
  function payment(response) {
    //Pass session id to your backend here
    if (response.isSuccess) {
      switch (response.paymentType) {
        case "ApplePay":
          console.log("Apple Pay Response>>\n" + JSON.stringify(response));
          break;
        case "GooglePay":
          console.log("Google Pay response >>\n" + JSON.stringify(response));
          break;
        case "Card":
          console.log("Card Response >>\n" + JSON.stringify(response));
          break;
        case "StcPay":
          console.log("STC Pay response >>\n" + JSON.stringify(response));
          break;
        default:
          console.log("Unknown payment type >>\n" + JSON.stringify(response));
          break;
      }
    } else {
      console.log("error", response);
    }
  }

  const submitCvv = () => {
    if (window.myfatoorah) {
      window.myfatoorah.submitCvv();
    }
  };

  return (
    <div style={{ backgroundColor: 'white', padding: '20px' }}>
      <div style={{ width: '400px', margin: 'auto' }}>
        <div id="unified-session"></div>
      </div>
      {/* <!-- This is a div element can be used as a container for Google Pay --> */}
        <div style={{width: "400px",margin: 0, position: "absolute", top: 0, left: 0}}>
            <div id="google-pay"></div>
        </div>
    </div>
  );
};

export default PaymentPage;


// import React, { useRef, useEffect, useState } from 'react';

// const PaymentPage = () => {
//   const iframeRef = useRef(null);
//   const [isMyFatoorahReady, setMyFatoorahReady] = useState(false);



//   useEffect(() => {
//     const script = document.createElement('script');
//     script.src = 'https://demo.myfatoorah.com/applepay/v3/applepay.js';
//     // https://demo.myfatoorah.com/googlepay/v1/googlepay.js
//     // https://demo.myfatoorah.com/stcPay/v1/stcpay.js
//     script.async = true;
//   //  const script2 = document.createElement('script');
//   //   script2.src = 'https://demo.myfatoorah.com/applepay/v3/applepay.js';
//   //   script2.async = true;
//     script.onload = async () => {
//       console.log('MyFatoorah script loaded successfully.');

//       // احصل على sessionId وبيانات التهيئة من السيرفر
//       // const res = await fetch('/api/initiate-payment'); // ← هذا API يجب أن يرجع sessionId
//       // const data = await res.json();

//       // هيئ myFatoorah

//               var config = {
//             sessionId: "a09682d8-c914-4bf8-98df-eca56a464999", // Here you add the "SessionId" you receive from InitiateSession Endpoint.
//             countryCode: "KWT", // Here, add your Country Code.
//             currencyCode: "KWD", // Here, add your Currency Code.
//             amount: "10", // Add the invoice amount.
//             cardViewId: "card-element",
//             callback: handlePayNow,
//             style:{
//               frameHeight: 51,
//               button: {
//                 height: "35px",
//                 // type: "Book", // Accepted texts ["Plain", "Buy", "Pay", "Check Out", "Continue", "Book", "Donate", "Subscribe", "Reload", "Add Money", "Top Up", "Order", "Rent", "Support", "Contribute", "Tip", "Set Up"]
//                 borderRadius: "8px"
//               }
//             }
//         };

//           window?.myFatoorahAP?.init(config);

//     //   window.myFatoorah.init({
//     //     countryCode: "KWT", // مثل: "SA"
//     //         currencyCode: "KWD", // Here, add your Currency Code.
//     //         amount: "10", // Add the invoice amount.
//     //     sessionId:"a09682d8-c914-4bf8-98df-eca56a464999",
//     //    cardViewId: "card-element",
//     // // supportedNetworks: "v,m,md,ae,Pay" , // مثل: 2 لبطاقة مدى، 1 لفيزا/ماستر
//     //  style:{
//     //           frameHeight: 51,
//     //           button: {
//     //             height: "35px",
//     //             type: "Pay", // Accepted texts ["Plain", "Buy", "Pay", "Check Out", "Continue", "Book", "Donate", "Subscribe", "Reload", "Add Money", "Top Up", "Order", "Rent", "Support", "Contribute", "Tip", "Set Up"]
//     //             borderRadius: "8px"
//     //           }
//     //         }
//     //   });
//  console.log('myFatoorah');
//       setMyFatoorahReady(true);
//     };

//     script.onerror = () => {
//       console.error('Failed to load MyFatoorah script.');
//     };

//     document.body.appendChild(script);

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, []);

//   const handlePayNow = async () => {
//     if (!window.myFatoorah) return alert('MyFatoorah not loaded');

//     try {
//       const response = await window.myFatoorah.submit();

//       const sessionId = response.sessionId;
//       const cardBrand = response.cardBrand;
//   console.log('Error>>>>>>>>response>>>>>>>>>>>>>>>>>: ' , response);
//       // أرسل sessionId للسيرفر لإتمام الدفع
//       executePaymentCall(sessionId);
//     } catch (error) {
//        console.log('Error>>>>>>>>>>>>>>>>>>>>>>>>>: ' , error);
//     }
//   };

//   const executePaymentCall = async (sessionId) => {
//     try {
//       console.log('executePaymentCall:', sessionId);
//       const res = await fetch('executePayment.php', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: new URLSearchParams({ sessionId }),
//       });
//     console.info('res:', res);
//       const paymentUrl = await res.text();
//        console.error('paymentUrl:', paymentUrl);
//       if (iframeRef.current) {
//         iframeRef.current.src = paymentUrl;
//       }
//     } catch (err) {
//       console.error('Payment error:', err);
//     }
//   };

//   return (
//     <div>
//       <button onClick={handlePayNow} disabled={!isMyFatoorahReady}>
//         Pay Now
//       </button>
// <div id="card-element"></div>
//       <iframe
//         id="iframeContainer"
//         ref={iframeRef}
//         title="Payment"
//         style={{ width: '100%', height: '600px', border: 'none', marginTop: '20px' }}
//       ></iframe>
//     </div>
//   );
// };

// export default PaymentPage;
